import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-sessionstorage',
	templateUrl:'./SessionStoragePluginPage.html',
	styles: [],
	styleUrls:['./SessionStoragePluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class SessionStoragePluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_645 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>sessionstorage</artifactId>
</dependency>
\`\`\``;
	mdContent_646 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:sessionstorage:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_647 = `\`\`\`java
@Inject
@Named("sessionstorage")
private UUID tabId;

// Use tabId to identify the specific browser tab
\`\`\``;
	mdContent_648 = `\`\`\`java
// Inject the per-tab identifier anywhere in call scope
@Inject
@Named("sessionstorage")
private UUID tabId;
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
